/**
 * DriveStatusBadge — iter-115c
 *
 * Drive errors and reconsent prompts MUST NOT surface anywhere in
 * normal user workflows. Drive status / reconnect / "invalid_grant"
 * messaging now lives ONLY inside:
 *
 *     Settings → Connections → Google Drive
 *
 * The component file is kept (other places import it) but the global
 * bottom-right badge no longer renders.
 */
export default function DriveStatusBadge() {
  return null;
}
